import { render, staticRenderFns } from "./HelpCenterSearchSkeleton.vue?vue&type=template&id=1d0e35c1&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports